module.exports = __webpack_public_path__ + "media/images/icons/icons_small/57_rose-a1cfc531db8b5ba9081ff5fe37aba011.png";